import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AiOutlinePlus } from 'react-icons/ai';
import PageHero from '../components/PageHero';

const FAQ_DATA = [
  {
    question: "What is your policy on illegal or prohibited content?",
    answer: "Customers must not stream any content which is illegal/prohibited as per Indian laws. We will not be liable for any consequences that arise out of violation of this condition, and we will not allow such customers to book with us again."
  },
  {
    question: "Can customers make changes to the technical equipment setup?",
    answer: "Customers should not make adjustments or modifications to the setup of projector, screen, laptop, and sound system. If any changes are required, we will do it from our end."
  },
  {
    question: "Are minors allowed to book the theater?",
    answer: "Individuals below 18 years of age cannot book the theater. Legal guardians can book the theater and bring their minor ward(s) along with them."
  },
  {
    question: "What is your refund policy for cancellations?",
    answer: "Full Refund of the Amount will be given if the booking is cancelled at least 72 hours before the booking time."
  },
  {
    question: "What happens in case of a technical interruption from your end?",
    answer: "If there is any failure in working of the projector, laptop, internet access or sound system - we will reimburse the paid amount after deducting the rent for the period of time before interruption."
  },
  {
    question: "Who is responsible for damages caused to the theater?",
    answer: "If there is any damage to any of the technical or non-technical items in the theater including the walls, lights, seating, etc., the customers will have to pay for it."
  }
];

const About = () => {
  const [openFaq, setOpenFaq] = React.useState(null);

  return (
    <div>
      <PageHero
        title="About Us"
        subtitle="We are the Best Private theatre in Bangalore providing Best celebration Experiences"
        image="/images/image6.jpeg"
        buttons={[
          { to: "/", label: "Home" },
          { to: "/branches", label: "Book slot" }
        ]}
      />

      {/* Main Content Section */}
      <section className="pt-6 pb-20 bg-gray-100">
        <div className="max-w-5xl mx-auto px-4">
          <motion.h2
            className="text-3xl md:text-4xl font-bold text-center mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Best Private Theatre & <br /> Celebration Space
          </motion.h2>
          <motion.p
            className="text-center mt-5 text-gray-600"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            We take pride in being the ultimate private theatre and celebration space, beautifully designed to make your special moments truly extraordinary. From cozy movie nights to grand birthday celebrations, romantic proposals, elegant bride-to-be parties, and more, our venue is tailored to suit every occasion. With stunning decorations, luxurious seating, and cutting-edge audio-visual systems, we create an ambiance that blends comfort, style, and exclusivity.
          </motion.p>

          <div className="flex gap-6 justify-center mt-12">
            <motion.div
              className="relative hidden md:block w-1/4 aspect-[3/4] rounded-2xl overflow-hidden shadow-xl"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                className="absolute w-full h-full object-cover"
                src="/images/image.jpeg"
                alt="celebration space"
              />
            </motion.div>
            <motion.div
              className="relative w-full md:w-2/4 aspect-[16/9] rounded-2xl overflow-hidden shadow-xl md:-mb-8 md:mt-8"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              {/* <video
                className="absolute w-full h-full object-cover"
                src="/videos/about-video.mp4"
                controls
                autoPlay
                loop
                playsInline
              /> */}
              <img
                className="absolute w-full h-full object-cover"
                src="/images/image8.jpeg"
                alt="celebration space"
              />
            </motion.div>
            <motion.div
              className="relative hidden md:block w-1/4 aspect-[3/4] rounded-2xl overflow-hidden shadow-xl"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                className="absolute w-full h-full object-cover"
                src="/images/image2.jpeg"
                alt="private theatre"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-5xl mx-auto px-4 flex flex-col md:flex-row items-center gap-12">
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-8">Our Brand Story</h2>
            <div className="space-y-4 text-gray-300">
              <p>In the heart of Bangalore, Happy Bubble was created with a vision to provide an extraordinary celebration space that combines luxury with comfort.</p>
              <p>We offer an intimate, luxurious setting for birthdays, anniversaries, and more, designed for unforgettable memories. Our brand quickly became a favorite for those seeking a personalized celebration experience.</p>
              <p>With a focus on customer satisfaction, each space combines comfort and style, offering a unique venue for gatherings of any size. Whether it's a small family event or a grand celebration, we set the perfect stage.</p>
            </div>
          </motion.div>
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img
              src="/images/image3.jpeg"
              alt="Brand Story"
              className="rounded-2xl shadow-2xl"
            />
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {FAQ_DATA.map((faq, index) => (
              <motion.div
                key={index}
                className="border border-gray-300 rounded-lg overflow-hidden bg-white"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <button
                  className="w-full flex justify-between items-center px-6 py-4 text-left"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  <span className="font-medium text-gray-900">{faq.question}</span>
                  <AiOutlinePlus
                    className={`transform transition-transform ${openFaq === index ? 'rotate-45' : ''}`}
                  />
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                >
                  <p className="px-6 pb-4 text-gray-600">{faq.answer}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 